 
import img1 from '../../Assets/2.png'
  import React from "react";
  import Slider from "react-slick";
  import "slick-carousel/slick/slick.css";
  import "slick-carousel/slick/slick-theme.css";
import { TypographyText, useScreenSize } from "../../Reuse/Reuse";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
function SamplePrevArrow(props) {
  const { style, onClick } = props;
  return (
    <div
      className="slickbuttonprev"
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KeyboardArrowLeftIcon />
    </div>
  );
}

function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    <div className="slickbuttonnext" onClick={onClick}>
      <KeyboardArrowRightIcon className="keybordarrow" />
    </div>
  );
}


const Data = [
  {bgImage: "https://tebewebe.online/pharamedic/wp-content/uploads/sites/40/2023/10/portrait-of-a-handsome-pharmacist-working-in-a-pharmacy.jpg",
  
    txt: "Market Overview",
    txt1: "India has 70 million rare disease patients, with a market size of $300 million and a growth rate of 10-12%.",
  },
  {bgImage:"https://img.freepik.com/premium-photo/three-pharmacists-working-pharmacy-checking-inventory-examining-medical-records_1361985-1148.jpg",
    
    txt: "Regulatory Environment",
    txt1: "The National Policy for Rare Diseases (NPRD) supports funding and subsidies for treatment access.",
  },
  {bgImage:"https://tebewebe.online/pharamedic/wp-content/uploads/sites/40/2023/10/young-female-pharmacist-posing-while-working-in-a-pharmacy-e1697689073593.jpg",
    txt: "Challenges",
    txt1: "Low awareness and delayed diagnoses limit treatment access amid high costs and poor infrastructure.",
  },
  {
   
    bgImage:"https://media.istockphoto.com/id/493302504/photo/testing-substances.jpg?s=612x612&w=0&k=20&c=zxRr8On95eALl__Ff06rasZZt6oOud8gGH0_8GFRTH8=",
    txt: "Opportunities",
    txt1: "There's a need for affordable treatments and diagnostics, creating partnership opportunities with NGOs and government.",
  },
];

  export default function Content1() {
    const settings = {
      dots: true,
      infinite: true,
      
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      speed: 5000,
      autoplaySpeed: 5000, 
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      responsive: [
        {
          breakpoint: 768, // For tablets and smaller
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480, // For mobile devices
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
    const matches2 = useScreenSize();
    return (<Box>
      <Box
      sx={{pt:'3%',pb:'3%',pl:'5%',pr:'5%'}}
      id="whyus">
                   <TypographyText
                      Typography={<>Why us</>}
                      // color="white"
                      textAlign="center"
                      variant={matches2 ? "h4" : "h5"}
                    //   fontWeight="600"
                    />
      </Box>
 
<Slider {...settings}>
      
         {Data.map((item, index) => (
         <Grid
        container
        // spacing={2}
        id="home"
        sx={{
          position: "relative",
width:'100%',

index:0,
          backgroundImage: `url(${item.bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "50% 40%",
          overflow: "hidden",
height:"100vh",
          margin:0,
          display:'flex !important',             justifyContent: "center",  // This ensures horizontal centering
        alignItems: "center",      // This ensures vertical centering
        }}
      >
        <Box
          sx={{
            width:'100%',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
             backgroundColor:"rgba(19, 43, 44, 0.5)",
         
            zIndex: 1,
          }}
        />

        <Grid
          item
          xs={12}
          sx={{
       

            zIndex: 2,
          }}
        >
                <TypographyText
                Typography={item.txt}
                fontSize= "2rem"
                
        color="white"
              textAlign="center"
              
              />
              <TypographyText
                Typography={item.txt1}
                fontSize="1rem"
                color="white"
              textAlign="center"
              />
        </Grid>
      </Grid>
        ))}
   </Slider>

   </Box> );
  }
